<template>
    <section
        ref="section1"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head
            :routes="routes"
            :step="1"
        ></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex flex-col gap-10 lg:w-full lg:gap-11 pb-32">
                <v-error-display :validation-errors="validationErrors"></v-error-display>
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="start-step-form"
                >
                    <v-csrf-token></v-csrf-token>
                    <figure class="mx-auto max-w-xl flex flex-col gap-9">
                        <figure class="flex gap-3">
                            <div><v-icon icon="house-dots" size="8"></v-icon></div>
                            <div class="flex flex-col justify-center">
                                <div class="text-heading-3-desktop">
                                    Izberite vrsto posredovanja
                                </div>
                            </div>
                        </figure>
                        <div class="grid grid-cols-2 grid-rows-1 gap-6 lg:flex lg:flex-wrap lg:justify-center lg:gap-4">
                            <div name="prodaja" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', validationErrors.vermarktungsart ? 'has-errors' : '']">
                                <input
                                    type="radio"
                                    name="vermarktungsart"
                                    id="rent-or-sell-1"
                                    value="kauf"
                                    class="hidden"
                                    v-model="marketingMethod"
                                />
                                <label for="rent-or-sell-1" class="flex min-h-[171px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all">
                                    <img
                                        :src="$assetsUrl + '/images/sell.webp'"
                                        alt="Hiša"
                                        class="pointer-events-none mb-4 min-h-[80px] w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Prodaja</span>
                                </label>
                            </div>
                            <div name="oddaja" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', validationErrors.vermarktungsart ? 'has-errors' : '']">
                                <input
                                    type="radio"
                                    name="vermarktungsart"
                                    id="rent-or-sell-2"
                                    value="miete"
                                    class="hidden"
                                    v-model="marketingMethod"
                                />
                                <label for="rent-or-sell-2" class="flex min-h-[171px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all">
                                    <img
                                        :src="$assetsUrl + '/images/rent.webp'"
                                        alt="Stanovanje"
                                        class="pointer-events-none mb-4 min-h-[80px] w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Oddaja</span>
                                </label>
                            </div>
                        </div>
                    </figure>
                    <v-separator classes="max-w-2xl mx-auto" v-if="prerequisitesMet('estateType')"/>
                    <figure class="max-w-xl mx-auto flex flex-col gap-9" v-if="prerequisitesMet('estateType')">
                        <figure class="flex gap-3">
                            <div><v-icon icon="house-dots" size="8"></v-icon></div>
                            <div class="flex flex-col justify-center">
                                <div class="text-heading-3-desktop">
                                    Izberite vrsto vaše nepremičnine
                                </div>
                            </div>
                        </figure>
                        <div class="grid grid-cols-2 grid-rows-2 gap-4 lg:flex lg:flex-wrap lg:justify-center items-stretch">
                            <div name="hisa" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-1"
                                    value="haus"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-1" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/hisa_3.webp'"
                                        alt="Hiša"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Hiša</span>
                                </label>
                            </div>

                            <div name="novogradnjahisa" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]" v-if="marketingMethod != 'miete'">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-5"
                                    value="hausbau"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-5" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/novogradnja_hisa.webp'"
                                        alt="Novogradnja hiša"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Novogradnja hiša</span>
                                </label>
                            </div>

                            <div name="stanovanje" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-2"
                                    value="wohnung"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-2" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/stanovanje_3.webp'"
                                        alt="Stanovanje"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Stanovanje</span>
                                </label>
                            </div>

                            <div name="stanovanje" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]" v-if="marketingMethod != 'miete'">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-4"
                                    value="ind_Schl_3259"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-4" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/novogradnja_stanovanje.webp'"
                                        alt="Novogradnja stanovanje"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none text-center">Novogradnja stanovanje</span>
                                </label>
                            </div>

                            <div name="parcela" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]" v-if="marketingMethod != 'miete'">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-3"
                                    value="grundstueck"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-3" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/parcela.webp'"
                                        alt="Parcela"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Parcela</span>
                                </label>
                            </div>

                            <div name="soba" :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.objektart ? 'has-errors' : '')]" v-if="marketingMethod != 'kauf'">
                                <input
                                    type="radio"
                                    name="objektart"
                                    id="real_estate_type-0"
                                    value="zimmer"
                                    class="hidden"
                                    v-model="estateType"
                                />
                                <label for="real_estate_type-0" class="flex cursor-pointer h-full flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all aspect-square">
                                    <img
                                        :src="$assetsUrl +'/images/soba_3.webp'"
                                        alt="Soba"
                                        class="pointer-events-none mb-4 w-20 select-none transition-all"
                                    />
                                    <span class="pointer-events-none select-none">Soba</span>
                                </label>
                            </div>
                        </div>
                    </figure>
                    <v-separator classes="max-w-2xl mx-auto" v-if="prerequisitesMet('estateUsage')"/>
                    <figure class="ml-auto mr-auto flex w-full max-w-xl flex-col gap-8" v-if="prerequisitesMet('estateUsage')">
                        <figure class="flex gap-3">
                            <div><v-icon icon="home-arrows-circle" size="8"></v-icon></div>
                            <div class="flex flex-col gap-3">
                                <div class="text-heading-3-desktop">
                                        Nepremičnina se lahko uporabi za
                                </div>
                                <div class="text-body-regular text-black-40">
                                    Izberete lahko samo eno možnost.
                                </div>
                            </div>
                        </figure>
                        <v-option-dropdown 
                            :options="usageTypeOptions" 
                            name="nutzungsart" 
                            label="Uporabi se lahko za..." 
                            :default-value="old.nutzungsart ? old.nutzungsart : stepData.nutzungsart" 
                            ref="estateUsageRef" 
                            :on-change="onUsageChange"
                        />
                    </figure>
                    <v-separator classes="max-w-2xl mx-auto" v-if="prerequisitesMet('address')"/>
                    <figure class="ml-auto mr-auto flex w-full max-w-xl flex-col gap-8" v-if="prerequisitesMet('address')">
                        <figure class="flex gap-3">
                            <div><v-icon icon="map-pin" size="8"></v-icon></div>
                            <div class="flex flex-col gap-3">
                                <div class="text-heading-3-desktop">
                                    Vnesite naslov nepremičnine
                                </div>
                                <div class="text-body-regular text-black-40">
                                    Izberete lahko ali bo naslov nepremičnine viden na oglasu.
                                </div>
                            </div>
                        </figure>
                        <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-6">
                            <li class="col-span-2">
                                <v-form-input
                                    id="propertyAddress"
                                    label="Naslov"
                                    type="text"
                                    :value="propertyAddress"
                                    v-model="propertyAddress"
                                    name="strasse"
                                    :error-message="validationErrors.strasse ? validationErrors.strasse[0] : null"
                                ></v-form-input>
                            </li>
                            <li class="col-span-2">
                                <v-form-input
                                    id="propertyNumber"
                                    label="Hišna številka"
                                    type="text"
                                    :value="propertyNumber"
                                    v-model="propertyNumber"
                                    name="hausnummer"
                                    :error-message="validationErrors.hausnummer ? validationErrors.hausnummer[0] : null"
                                ></v-form-input>
                            </li>
                            <li class="col-span-4">
                                <div class="relative flex items-center">
                                    <label
                                        for="location"
                                        class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full bg-white px-6 font-medium text-black-50 ring-1 ring-inset ring-gray"
                                        v-if="!hideCountryLabel && (countryOption == null || countryOption.value == '')"
                                        @click="openCountry"
                                    >
                                        <div class="overflow-hidden text-ellipsis whitespace-nowrap">
                                            <span class="text-[14px] font-medium text-black-40">
                                                Država
                                            </span>
                                        </div>
                                    </label>
                                    <v-select
                                        class="v-select--xs w-full rounded-full bg-white font-medium ring-1 ring-inset ring-gray"
                                        :options="parseCountries()"
                                        placeholder=""
                                        v-model="countryOption"
                                        label="custom_label"
                                        @search:focus="onFocusCountry"
                                        @search:blur="onBlurCountry"
                                        ref="location"
                                        id="location"
                                        :name="'location'"
                                        @option:selecting="populateFieldsCountry"
                                    >
                                        <template v-slot:no-options>
                                            Za ta iskalni niz ni zadetkov.
                                        </template>
                                    </v-select>
                                    <input
                                        type="hidden"
                                        name="land"
                                        :value="countryOption == null ? '' : countryOption.value"
                                    />
                                </div>
                            </li>
                            <li class="col-span-4">
                                <div class="relative flex items-center">
                                    <label
                                        for="location"
                                        class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full bg-white px-6 font-medium text-black-50 ring-1 ring-inset ring-gray"
                                        v-if="!hideLocationLabel && (locationOption == null || locationOption.value == '')"
                                        @click="openLocation"
                                    >
                                        <div class="overflow-hidden text-ellipsis whitespace-nowrap">
                                            <span class="text-[14px] font-medium text-black-40">
                                                Kraj
                                            </span>
                                        </div>
                                    </label>
                                    <v-select
                                        class="v-select--xs w-full rounded-full bg-white font-medium ring-1 ring-inset ring-gray"
                                        :options="parseLocations"
                                        placeholder=""
                                        v-model="locationOption"
                                        label="custom_label"
                                        @search:focus="onFocus"
                                        @search:blur="onBlur"
                                        ref="location"
                                        id="location"
                                        :name="'location'"
                                        @option:selecting="populateFields"
                                    >
                                        <template v-slot:no-options>
                                            Za ta iskalni niz ni zadetkov.
                                        </template>
                                    </v-select>
                                    <input
                                        type="hidden"
                                        name="regionaler_zusatz"
                                        :value="locationOption == null ? '' : locationOption.value"
                                    />
                                    <!-- Scout region 
                                    <input
                                        type="hidden"
                                        name="scout_region"
                                        :value="scoutRegion"
                                    />    
                                    -->                                
                                </div>
                                <!-- Scout region
                                <template v-if="validationErrors.scout_region">
                                    <div class="mb-4 w-full pt-0 text-small-text-regular text-salmon">
                                        Polje za regijo se ni nastavilo samodejno, prosimo kontaktirajte našo skupino.
                                    </div>
                                </template> -->
                            </li>
                            <li class="col-span-4">
                                <v-form-input
                                    id="propertyPostalNumber"
                                    label="Poštna številka"
                                    type="text"
                                    :value="propertyPostalNumber"
                                    v-model="propertyPostalNumber"
                                    name="plz"
                                ></v-form-input>
                            </li>
                            <li class="col-span-4">
                                <v-checkbox
                                    :id="'show_location'"
                                    class="text-small-text-medium text-black-78"
                                    :label="'Ali želite, da je lokacija nepremičnine na oglasu vidna?'"
                                    checkbox-position="right"
                                    :name="'show_location'"
                                    :value="1"
                                    @vchanged="showLocation = !showLocation"
                                    :checked="Boolean(showLocationComputed)"
                                ></v-checkbox>
                                <input
                                    type="hidden"
                                    :value="showLocationComputed"
                                    name="objektadresse_freigeben"
                                />
                            </li>
                            <v-form-input
                                class="hidden"
                                id="propertyPlace"
                                label="Kraj"
                                type="text"
                                :value="propertyPlace"
                                v-model="propertyPlace"
                                name="ort"
                            ></v-form-input>
                        </ul>
                    </figure>
                    <v-separator classes="max-w-2xl mx-auto" v-if="prerequisitesMet('address')"/>
                    <figure class="ml-auto mr-auto flex w-full max-w-xl flex-col gap-8" v-if="prerequisitesMet('address')">
                        <figure class="flex gap-3">
                            <div>
                                <v-icon icon="tag" size="8"></v-icon>
                            </div>
                            <div class="flex flex-col gap-3">
                                <div class="text-heading-3-desktop">
                                    Po kakšni ceni prodajate nepremičnino
                                </div>
                            </div>
                        </figure>

                        <!-- Selling price section -->
                        <figure class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8" v-if="marketingMethod == 'kauf'">
                            <ul class="flex flex-col gap-8">
                                <li class="w-full">
                                    <div :class="['input group relative flex flex-col gap-[10px]', validationErrors.preis ? 'has-errors' : '']">
                                        <label for="addPrice" class="w-full text-body-medium-button">
                                            <div class="label flex flex-col gap-[10px]">
                                                <div class="flex items-center gap-3">
                                                    <v-icon icon="euro" size="4"></v-icon>
                                                    <span>Ponudbena cena<sup>*</sup></span>
                                                </div>
                                            </div>
                                        </label>

                                        <v-form-input
                                            id="addPrice"
                                            type="number"
                                            :value="price"
                                            v-model="price"
                                            name="preis"
                                        ></v-form-input>
                                        <span class="absolute bottom-[18px] right-6 text-body-medium-button" :class="price ? 'text-black-78' : 'text-black-40'">€</span>
                                    </div>
                                </li>

                                <li class="w-full">
                                    <v-checkbox
                                        label="Brez provizije"
                                        checkbox-position="right"
                                        name="brezProvizije"
                                        :checked="Boolean(provisionCasted)"
                                        icon="add-card"
                                        @vchanged="provision = !provision"
                                    ></v-checkbox>
                                </li>

                                <li v-show="!Boolean(provisionCasted)" class="w-full">
                                    <div :class="['textarea group flex items-center', validationErrors.preis ? 'has-errors' : '']">
                                        <label for="visinaProvizijeZaKupca" class="flex w-full flex-col gap-[10px] text-body-medium-button">
                                            <div class="label flex flex-col gap-10">
                                                <div class="flex items-start gap-3">
                                                    <v-icon icon="percent"></v-icon>
                                                    <div class="flex flex-col gap-[10px]">
                                                        <div>Višina provizije za kupca</div>
                                                        <small class="text-body-regular text-black-40">
                                                            Opišite podrobno višino provizije v %, z ali brez DDV-ja in pogoje plačila provizije.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            <textarea
                                                id="visinaProvizijeZaKupca"
                                                name="aussen_courtage"
                                                placeholder="Višina provizije za kupca"
                                                rows="10"
                                                class="pl-7"
                                                v-model="provisionAmount"
                                            ></textarea>
                                            <small class="flex w-full justify-end text-small-text-regular text-black-40">0/80 besed</small>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                            <input type="text" name="provisionsfrei" class="hidden" v-model="provisionCasted" />
                        </figure>

                        <!-- Rental price section -->
                        <figure class="ml-auto mr-auto max-w-lg w-full" v-if="marketingMethod == 'miete'">
                            <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8">
                                <li class="col-span-4">
                                    <div :class="['input group relative flex flex-col gap-[10px]', validationErrors.kaltmiete ? 'has-errors' : '']">
                                        <label for="netoNajemnina" class="w-full text-body-medium-button">
                                            <div class="label flex flex-col gap-[10px]">
                                                <div class="flex items-center gap-3">
                                                    <v-icon icon="payments" size="4"></v-icon>
                                                    <span>
                                                        <span v-text="stepData.kaltmieteLabel"></span>
                                                        <sup>*</sup>
                                                    </span>
                                                </div>
                                            </div>
                                        </label>

                                        <v-form-input
                                            id="netoNajemnina"
                                            type="number"
                                            v-model="kaltmiete"
                                            :value="kaltmiete"
                                            name="kaltmiete"
                                            :placeholder="stepData.kaltmieteLabel"
                                        ></v-form-input>
                                        <div class="absolute bottom-[18px] right-6 text-body-medium-button" :class="kaltmiete ? 'text-black-78' : 'text-black-40'">€/mesec</div>
                                    </div>
                                </li>

                                <li class="col-span-4">
                                    <div :class="['input group relative flex flex-col gap-[10px]', validationErrors.warmmiete ? 'has-errors' : '']">
                                        <label for="netoNajemnina" class="w-full text-body-medium-button">
                                            <div class="label flex flex-col gap-[10px]">
                                                <div class="flex items-center gap-3">
                                                    <v-icon icon="payments" size="4"></v-icon>
                                                    <span>
                                                        <span v-text="stepData.warmmieteLabel"></span>
                                                        <sup>*</sup>
                                                    </span>
                                                </div>
                                            </div>
                                        </label>

                                        <v-form-input
                                            id="brutoNajemnina"
                                            type="number"
                                            v-model="warmmiete"
                                            :value="warmmiete"
                                            name="warmmiete"
                                            :placeholder="stepData.warmmieteLabel"
                                        ></v-form-input>
                                        <div class="absolute bottom-[18px] right-6 text-body-medium-button" :class="warmmiete ? 'text-black-78' : 'text-black-40'">€/mesec</div>
                                    </div>
                                </li>
                            </ul>
                        </figure>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('start-step-form')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";
import SectionSeparator from "../SectionSeparator.vue";
import OptionDropdown from '../OptionDropdown.vue';
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
        "v-separator": SectionSeparator,
        "v-option-dropdown": OptionDropdown,
        "v-error-display": ErrorDisplay,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            marketingMethod: null,
            estateType: null,
            usageType: null,
            locationOption: null,
            countryOption: null,
            hideLocationLabel: false,
            hideCountryLabel: false,
            propertyAddress: null,
            propertyNumber: null,
            propertyPostalNumber: null,
            propertyPlace: null,
            showLocation: false,
            showCountry: false,
            price: null,
            provision: false,
            provisionAmount: null,
            kaltmiete: null,
            warmmiete: null,
        };
    },
    mounted() {
        this.marketingMethod = (this.old.vermarktungsart ? this.old.vermarktungsart : this.stepData.vermarktungsart) ?? null;
        this.estateType = (this.old.objektart ? this.old.objektart : this.stepData.objektart) ?? null;
        this.usageType = (this.old.nutzungsart ? this.old.nutzungsart : this.stepData.nutzungsart) ?? null;

        this.countryOption = {
            value: this.old.land ? this.old.land : (this.stepData.land ?? 'SVN'),
            custom_label: this.countryToLabel(this.old.land ? this.old.land : (this.stepData.land ?? 'SVN')),
        };

        this.locationOption = {
            value: (this.old.regionaler_zusatz ? this.old.regionaler_zusatz : this.stepData.regionaler_zusatz) ?? null,
            custom_label: this.regionalerZusatzLabel(this.old.regionaler_zusatz ? this.old.regionaler_zusatz : this.stepData.regionaler_zusatz) ?? null,
            //region: (this.old.scout_region ? this.old.scout_region : this.stepData.scout_region) ?? null,
        };

        this.propertyAddress = (this.old.strasse ? this.old.strasse : this.stepData.strasse) ?? null;
        this.propertyNumber = (this.old.hausnummer ? this.old.hausnummer : this.stepData.hausnummer) ?? null;
        this.propertyPostalNumber = (this.old.plz ? this.old.plz : this.stepData.plz) ?? null;
        this.propertyPlace = (this.old.ort ? this.old.ort : this.stepData.ort) ?? null;
        this.showLocation = (this.old.objektadresse_freigeben ? this.old.objektadresse_freigeben : this.stepData.objektadresse_freigeben) ?? null;
        this.price =(this.old.preis ? this.old.preis : this.stepData.preis) ?? null;
        this.provision =(this.old.provisionsfrei ? this.old.provisionsfrei : this.stepData.provisionsfrei) ?? null;
        this.provisionAmount =(this.old.aussen_courtage ? this.old.aussen_courtage : this.stepData.aussen_courtage) ?? null;
        this.kaltmiete =(this.old.kaltmiete ? this.old.kaltmiete : this.stepData.kaltmiete) ?? null;
        this.warmmiete =(this.old.warmmiete ? this.old.warmmiete : this.stepData.warmmiete) ?? null;
        //this.scoutRegion = (this.old.scout_region ? this.old.scout_region : this.stepData.scout_region) ?? null;
    },
    methods: {
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
        onUsageChange(newValue) {
            this.usageType = newValue;
        },
        prerequisitesMet(section) {
            // We are at type
            if (section == 'marketingMethod') {
                return true;
            }

            // We are at subtype
            if (section == 'estateType') {
                if (this.marketingMethod === null || this.marketingMethod == "") {
                    return false
                }
            }

            if (section == 'estateUsage') {
                if (this.estateType === null || this.estateType == "") {
                    return false
                }
            }

            if (section == 'address') {
                if (this.usageType === null || this.usageType == "") {
                    return false
                }
            }

            return true;
        },
        countryToLabel(value) {
            if (value === 'SVN') {
                return 'Slovenija';
            }

            if (value === 'HRV') {
                return 'Hrvaška';
            }

            return null;
        },
        regionalerZusatzLabel(value) {
            let country = this.old.land ? this.old.land : (this.stepData.land ?? 'SVN');
            let label = null;
            Object.values(this.stepData.locations).filter((item) => item.country === country).forEach((object) => {
                if (object.code == value) {
                    label = object.location;
                }
            });

            return label;
        },
        populateFields(selectedLocation) {
            this.propertyPlace = selectedLocation.custom_label;
            this.propertyPostalNumber = selectedLocation.postal_code;
        },
        populateFieldsCountry(selectedCountry) {
            this.propertyPlace = null;
            this.propertyPostalNumber = null;
            this.locationOption = null;
        },
        openLocation() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.location;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        openCountry() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.country;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        parseCountries() {
            return [
                {value: 'SVN', custom_label: this.countryToLabel('SVN')},
                {value: 'HRV', custom_label: this.countryToLabel('HRV')},
            ]
        },
        onFocus() {
            this.hideLocationLabel = true;
        },
        onBlur() {
            this.hideLocationLabel = false;
        },
        onFocusCountry() {
            this.hideLocationLabel = true;
        },
        onBlurCountry() {
            this.hideLocationLabel = false;
        },
    },
    watch: {
        /*locationOption(newValue, oldValue) {
            this.scoutRegion = newValue.region;
        },*/
        marketingMethod(newValue, oldValue) {
            if (oldValue !== null) {
                this.estateType = null;
                this.usageType = null;
                this.$refs.estateUsageRef?.resetValue();
                this.price = null;
                this.provision = null;
                this.provisionAmount = null;
                this.kaltmiete = null;
                this.warmmiete = null;
            }
        },
        estateType: {
            handler (newValue, oldValue) {
                if (oldValue != null) {
                    this.usageType = null;
                    this.$refs.estateUsageRef?.resetValue();
                }
            }
        },
    },
    computed: {
        provisionCasted() {
            return this.provision ? 1 : 0;
        },
        estateTypeOptions(){
            return this.stepData.objekttyp_options[this.estateType].map((option) => { return {label: option.label, value: option.enum}})
        },
        usageTypeOptions() {
            return [
                {label: 'Bivanje', value: 'wohnen'},
                {label: 'Poslovni prostor', value: 'gewerbe'},
                {label: 'Kratkoročna oddaja', value: 'waz'},
                {label: 'Naložba', value: 'anlage'}
            ];
        },
        parseLocations() {
            let parsedLocations = [];

            Object.values(this.stepData.locations).filter((item) => item.country === this.countryOption?.value ?? 'SVN').forEach((object) => {
                parsedLocations.push({
                    value: object.code,
                    custom_label: object.location,
                    postal_code: object.postal_code,
                    //region: object.region,
                });
            });

            return parsedLocations;
        },
        showLocationComputed() {
            return this.showLocation ? 1 : 0;
        },
        showCountryComputed() {
            return this.showLocation ? 1 : 0;
        },
        validated() {
            if (!this.marketingMethod) {
                return false;
            }

            if(!this.estateType) {
                return false
            }

            if(!this.usageType) {
                return false;
            }

            if (
                !this.locationOption ||
                !this.locationOption.value ||
                !this.propertyAddress ||
                !this.propertyNumber ||
                !this.propertyPostalNumber ||
                !this.propertyPlace
            )
                return false;

            if(this.marketingMethod == 'kauf') {
                if(!this.price) return false

                if(this.provisionCasted == 0 && !this.provisionAmount) return false

                return true;
            }

            if(this.marketingMethod == 'miete') {
                if(!this.kaltmiete || !this.warmmiete) return false
            }

            return true;
        },
    },
};
</script>
